import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../utils/error";
import { useRequest } from "../../utils/request";
import { accountBondingLineQueryKey } from "./account.keys";

export const useFetchAccountBondingLine = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: accountBondingLineQueryKey(accountId),
		queryFn: async () => {
			try {
				return await get<Dtos.SuretyAccount.BondingLine.Get.Response>(
					`/v2/surety/accounts/${accountId}/bonding-lines`,
				);
			} catch (error) {
				if (error instanceof ApiError && error.statusCode === 404) {
					return null;
				}

				throw error;
			}
		},
	});

	return {
		bondingLine: data,
		bondingLineError: error,
		bondingLineIsLoading: isLoading,
	};
};
